<template lang="html">
  <section class="news">
    <div class="row">
      <div id='loadingmessage' style="text-align:center;margin: 0px; padding: 0px; position: fixed; right: 0px; top: 0px; width: 100%; height: 100%; background-color: white; z-index: 30001; opacity: 0.8;" v-if="loading">
                            <p style="position: absolute; color: White; top: 40%; left: 40%;">
                                <img src='../../assets/snakes.gif' /></p>
                        </div>
      <div class="col-12 grid-margin">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Snakebite Information Management System</h4><hr>
            <div class="row">
                <div class="col-md-12">
                    
            <div class="big4">
             <b>Created Date : </b><span>{{cdate}}</span>
              </div>
              <div class="big4">
             <b>Link : </b><span><a v-bind:href="link" target="_blank">{{link}}</a></span>
           
            </div>
            <div class="big4">
             <b>Notes : </b><span>{{notes}}</span>
              </div>
               <div class="big4">
             <b>Tradition : </b><span>{{healing}}</span>
              </div>
               <div class="big4">
             <b>Affected People : </b><span>{{affectedpeople}}</span>
              </div>
               <div class="big4">
             <b>Status : </b><span>{{status}}</span>
              </div>
               <div class="big4">
             <b>State : </b><span>{{states}}</span>
              </div>
              <div class="big4">
             <b>Activity : </b><span>{{activity}}</span>
              </div>
              <div class="big4">
             <b>Hospitalized : </b><span>{{hospitalized}}</span>
              </div>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script lang="js">
import axios from 'axios'
import { VueEditor } from 'vue2-editor'
import Multiselect from 'vue-multiselect'
import vSelect from 'vue-select'
export default {
  name: 'news',
  props: ['id'],
  components: {
    VueEditor,
    Multiselect,
    vSelect
  },
  data () {
    return {
      cdate: '',
      link: '',
      notes: '',
      healing: '',
      affectedpeople: '',
      status: '',
      loading: false,
      error: '',
      option: ['Andhra Pradesh', 'Arunachal Pradesh', 'Assam', 'Bihar', 'Chhattisgarh', 'Goa', 'Gujarat', 'Haryana', 'Himachal Pradesh', 'Jammu and Kashmir', 'Jharkhand', 'Karnataka', 'Kerala', 'Madhya Pradesh', 'Maharashtra', 'Manipur', 'Meghalaya', 'Mizoram', 'Nagaland', 'Odisha', 'Punjab', 'Rajasthan', 'Sikkim', 'Tamil Nadu', 'Telangana', 'Tripura', 'Uttar Pradesh', 'Uttarakhand', 'West Bengal', 'Andaman and Nicobar', 'Chandigarh', 'Dadra and Nagar Haveli', 'Daman and Diu', 'Lakshadweep', 'Delhi', 'Puducherry'],
      selected: '',
      states: '',
      activity: '',
      hospitalized: '',
    }
  },
     mounted: function () {
    this.getList()
  },
  methods: {
    getList () {
      this.loading = true
      axios({
       url: 'https://api.indiansnakes.org/snakebiteinfo/get/',
        method: 'GET',
        params: {
        id: this.id
        },
        headers: {
                    'x-auth-token': localStorage.getItem("token")
                },
      }).then(response => {
        this.cdate = response.data.data.createddate.slice(0,10)
      this.link = response.data.data.linktonews
      this.notes = response.data.data.note
      this.healing = response.data.data.tradition
      this.affectedpeople = response.data.data.affectedpeople
      this.status = response.data.data.status
      this.states = response.data.data.state
      this.activity = response.data.data.activity
      this.hospitalized = response.data.data.hospitalized
        this.loading = false
      }).catch(e => {
        this.loading = false
      })
    },
  }
}
</script>
<style scoped lang="scss">
#preview {
  display: flex;
  justify-content: center;
  align-items: center;
}

#preview img {
  width: 20%;
}

.big4 {
  margin-bottom: 10px;
}
p {
  margin-top: 0;
  margin-bottom: 1px !important;
}
</style>


// WEBPACK FOOTER //
// src/views/forms/snakebitemanagementview.vue